import React from 'react';
import PropTypes from 'prop-types';

const CreatorButtons = props => (
  <div>
    <button
      id={props.addBtnData.id}
      className={props.addBtnData.className}
      onClick={props.addBtnData.click}
    >{props.addBtnData.text}</button>
    <button
      id={props.cancelBtnData.id}
      className={props.cancelBtnData.className}
      onClick={props.cancelBtnData.click}
    >{props.cancelBtnData.text}</button>
  </div>
);

CreatorButtons.propTypes = {
  addBtnData: PropTypes.shape({
    id: PropTypes.string,
    className: PropTypes.string,
    click: PropTypes.func,
    text: PropTypes.string,
  }).isRequired,
  cancelBtnData: PropTypes.shape({
    id: PropTypes.string,
    className: PropTypes.string,
    click: PropTypes.func,
    text: PropTypes.string,
  }).isRequired,
};

CreatorButtons.defaultProps = {
  addBtnData: {
    id: '',
    className: 'btn btn-large btn-success save-use-btn',
    click: () => {},
    text: 'Add Signature',
  },
  cancelBtnData: {
    id: '',
    className: 'btn btn-large save-use-btn',
    click: () => {},
    text: 'Cancel',
  },
};

export default CreatorButtons;



// WEBPACK FOOTER //
// ./src-react/SignatureManager/CreatorButtons.jsx